import React, {FC} from "react";
import {LookupItemModel, LookupTypeEnum, SearchPanelPropsModel, AccountsReportSearchParamsModel} from "../../../models";
import {Form} from "react-bootstrap";
import {getLabelName} from "../../../utils";
import {useLookups} from "../../../hooks";
import {ButtonBox, PrivilegesChecker, InputDatePicker, SelectBox} from "../..";

export const ReportGeneralLedgerPageSearchPanel: FC<
    SearchPanelPropsModel<AccountsReportSearchParamsModel>
> = ({
         setLoading,
         handelSearch,
         searchParams,
         setSearchParams, formId,
     }) => {
    //#region state
    const {getLookupItems} = useLookups(setLoading, [
        LookupTypeEnum.AC_Accounts,
        LookupTypeEnum.CostCenter,
        LookupTypeEnum.Employee,
        LookupTypeEnum.Users,
    ]);
    //#endregion
    //#region html
    return (
        <>
            <Form>
                <div
                    className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-1 g-sm-2 g-md-4 align-items-start"
                    // className="row row-cols-1 row-cols-md-2 g-3 align-items-start"
                    >
                    <InputDatePicker
                        selectedDate={searchParams.fromDate}
                        isClearable
                        InputLabel={"From Date"}
                        selectsStart
                        startDate={searchParams.fromDate}
                        endDate={searchParams.toDate}
                        className="form-control"
                        onChange={(date) => {
                            const obj = {...searchParams};
                            obj.fromDate = date === null ? undefined : date;
                            setSearchParams(obj);
                        }}
                    />
                    <InputDatePicker
                        selectedDate={searchParams.toDate}
                        isClearable
                        InputLabel={"To Date"}
                        selectsEnd
                        startDate={searchParams.fromDate}
                        endDate={searchParams.toDate}
                        minDate={searchParams.fromDate}
                        className="form-control"
                        onChange={(date) => {
                            const obj = {...searchParams};
                            obj.toDate = date === null ? undefined : date;
                            setSearchParams(obj);
                        }}
                    />
                    <SelectBox
                        labelName="Account"
                        isSingleSelect={true}
                        selectedValues={
                            searchParams.accountId
                                ? [searchParams.accountId.toString()]
                                : [""]
                        }
                        source={getLookupItems(LookupTypeEnum.AC_Accounts, true)}
                        onStatusChange={(e: LookupItemModel) => {
                            const obj = {...searchParams};
                            if (e == null) {
                                obj.accountId = undefined;
                            } else {
                                obj.accountId =
                                    e.value === "" || e.value === null
                                        ? undefined
                                        : parseInt(e.value);
                            }
                            setSearchParams(obj);
                        }}
                    />
                    <SelectBox
                        labelName="cost center"
                        isSingleSelect={true}
                        selectedValues={
                            searchParams.costCenterId
                                ? [searchParams.costCenterId.toString()]
                                : [""]
                        }
                        source={getLookupItems(LookupTypeEnum.CostCenter, true)}
                        onStatusChange={(e: LookupItemModel) => {
                            const obj = {...searchParams};
                            if (e == null) {
                                obj.costCenterId = undefined;
                            } else {
                                obj.costCenterId =
                                    e.value === "" || e.value === null
                                        ? undefined
                                        : parseInt(e.value);
                            }
                            setSearchParams(obj);
                        }}
                    />
                    <SelectBox
                        labelName="Employee"
                        isSingleSelect={true}
                        selectedValues={
                            searchParams.employeeId
                                ? [searchParams.employeeId.toString()]
                                : [""]
                        }
                        source={getLookupItems(LookupTypeEnum.Employee, true)}
                        onStatusChange={(e: LookupItemModel) => {
                            const obj = {...searchParams};
                            if (e == null) {
                                obj.employeeId = undefined;
                            } else {
                                obj.employeeId =
                                    e.value === "" || e.value === null
                                        ? undefined
                                        : parseInt(e.value);
                            }
                            setSearchParams(obj);
                        }}
                    />
                    <SelectBox
                        labelName="User"
                        isSingleSelect={true}
                        selectedValues={
                            searchParams.userId ? [searchParams.userId.toString()] : [""]
                        }
                        source={getLookupItems(LookupTypeEnum.Users, true)}
                        onStatusChange={(e: LookupItemModel) => {
                            const obj = { ...searchParams };
                            if (e == null) {
                                obj.userId = undefined;
                            } else {
                                obj.userId =
                                    e.value === "" || e.value === null
                                        ? undefined
                                        : parseInt(e.value);
                            }
                            setSearchParams(obj);
                        }}
                    />
                </div>
                <PrivilegesChecker formId={formId} action="EnableSearch">
                    <div className="col-12 d-flex justify-content-end mt-2">
                        <ButtonBox
                            iconType="magnify"
                            className="btn-gradient-primary btn-fw"
                            variant="outline-primary"
                            onClick={handelSearch}
                        >
                            {getLabelName("Search")}
                        </ButtonBox>
                    </div>
                </PrivilegesChecker>
            </Form>
        </>
    );
    //#endregion
};
